(function () {
	"use strict";

	angular.module("cardFrontConsumer")
        .config(config);

	config.$inject = ["$routeProvider", "NAV_URLS"];

	function config($routeProvider, NAV_URLS) {

		$routeProvider
            .when(NAV_URLS.ENTER_PIN, {
            	templateUrl: "areas/enter-pin/enter-pin.html",
            	controller: "EnterPin",
            	titleTranslationId: "ENTER_PIN.TITLE",
            	controllerAs: "model"
            });
	}

}());